import { AxiosPrivate } from '../../utils';
import { IAssetCategory } from '../../constants/assets';

interface IData {
  data: IAssetCategory;
}

class PlanningApi {
  private static instance: PlanningApi;

  public static getInstance(): PlanningApi {
    if (!PlanningApi.instance) {
      PlanningApi.instance = new PlanningApi();
    }

    return PlanningApi.instance;
  }

  getPlanning = (slug: string) => {
    return AxiosPrivate.get<IData>(`/v1/planning/${slug}`);
  };
}

export const planningApi = PlanningApi.getInstance();
